import { Calendar, Phone, ArrowUpRight } from "lucide-react";
import Label from "@/components/Label";
import { BUSINESS } from "@/data/content";

// Appointment scheduling block.
// Replace BUSINESS.bookingUrl in data/content.js with your Fresha/Square/Vagaro link,
// or drop your provider's <iframe> in place of the placeholder below.
export default function BookingEmbed({ service = "" }) {
  return (
    <div
      data-testid="booking-embed"
      className="relative border border-black/12 bg-white p-8 md:p-10"
    >
      <Label>Schedule</Label>
      <h3 className="mt-4 font-serif-display text-3xl md:text-4xl tracking-tight">
        Book Your Appointment
      </h3>
      <p className="mt-4 max-w-md text-sm leading-relaxed text-[#3d3d3d]">
        {service ? (
          <>Ready for your {service.toLowerCase()}? </>
        ) : null}
        Reserve online in seconds, or call us and our team will help you choose the right
        treatment and time.
      </p>

      <div className="mt-8 flex flex-col gap-3">
        <a
          href={BUSINESS.bookingUrl}
          target="_blank"
          rel="noreferrer"
          data-testid="booking-online-btn"
          className="group inline-flex w-full items-center justify-center gap-2 whitespace-nowrap bg-[#050505] px-6 py-4 text-sm uppercase tracking-[0.14em] text-white transition-colors duration-300 hover:bg-white hover:text-[#050505] border border-[#050505]"
        >
          <Calendar size={16} />
          Book Online
          <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
        </a>
        <a
          href={BUSINESS.phoneHref}
          data-testid="booking-call-btn"
          className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap border border-[#050505] px-6 py-4 text-sm uppercase tracking-[0.12em] text-[#050505] transition-colors duration-300 hover:bg-[#050505] hover:text-white"
        >
          <Phone size={16} /> {BUSINESS.phoneDisplay}
        </a>
      </div>

      <div className="mt-8 space-y-3 border-t border-black/10 pt-6 text-xs uppercase tracking-[0.14em]">
        <p className="mb-1 font-semibold text-[#050505]">Our Business Hours</p>
        {BUSINESS.hours.map((h) => (
          <div key={h.day} className="flex flex-col leading-snug">
            <span className="text-[#050505]">{h.day}</span>
            <span className="text-[#888]">{h.time}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
